import { OpenAPI, request as __request } from '/src/api';
import { ProgramBrokerFeeRate } from '/src/lib/models/ProgramBrokerFeeRate';

export class ProgramBrokerFeeRateService {
  /**
   * List Program Broker Fee Rates
   * @returns ProgramBrokerFeeRate[]
   */
  public static list(): Promise<ProgramBrokerFeeRate[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/programBrokerFeeRates',
    });
  }
}
